import { useLocation, useRoute } from "wouter";
import { TechnologyProfile } from "../components/TechnologyProfile";
import { AnimatePresence } from "framer-motion";

export function TechProfileScreen() {
	const [location] = useLocation();
	const [matchRadar, paramsRadar] = useRoute("/tech-radar/:slug");
	const [matchBreakdown, paramsBreakdown] = useRoute("/score-breakdown/:slug");
	//project info
	const [radarMatchInfo] = useRoute("/tech-radar/project-info");
	const [breakdownMatchInfo] = useRoute("/score-breakdown/project-info");
	return (
		<AnimatePresence initial={false} exitBeforeEnter={true}>
			{(matchRadar || matchBreakdown) &&
			!(radarMatchInfo || breakdownMatchInfo) ? (
				<TechnologyProfile
					key={location}
					slug={paramsRadar?.slug || paramsBreakdown?.slug}
				/>
			) : null}
		</AnimatePresence>
	);
}
